import { FC } from "react";
import { Link } from "react-router-dom";
import { ProjectSource, ProjectSourceType } from "../../../types/ProjectTypes";
import styles from "../ProjectView.module.less";

interface SourceBannerProps {
    source: ProjectSource;
}

/**
 * Small banner shown at the top of a project view when the project was
 * spawned from another (e.g. an RFx).
 */
export const SourceBanner: FC<SourceBannerProps> = ({ source }) => {
    if (source.type !== ProjectSourceType.RFX) return null;

    return (
        <div className={styles.sourceBanner}>
            Sourced from RFx:{" "}
            <Link to={`/project/${source.projectId}`}>{source.projectName}</Link>
        </div>
    );
};
